import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-77bdee91")
const _hoisted_1 = {
  key: 0,
  class: "arrow back"
}
const _hoisted_2 = {
  key: 1,
  class: "progress"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "No cards to show"),
  /*#__PURE__*/_createElementVNode("span", { style: {"opacity":"0.5"} }, "Click here to create one")
], -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = {
  key: 0,
  style: {"opacity":"0.5"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "questions"
}
const _hoisted_9 = { class: "question" }
const _hoisted_10 = {
  key: 3,
  class: "questions",
  style: {"opacity":"0.5"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "functions" }, null, -1)
const _hoisted_12 = { class: "icons" }
const _hoisted_13 = {
  key: 2,
  class: "arrow next"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    pagecontrols:true,
    reorder:_ctx.$store.state.GameEdit.reordering
  })
  }, [
    (!_ctx.$store.state.GameEdit.reordering)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_IconButton, {
            icon: "chevron_left",
            white: true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveTo(_ctx.$store.state.GameEdit.cards.focus-1)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.fullPath.includes('/developer'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.gameeditmeta && _ctx.$store.state.GameEdit.cards && !_ctx.$store.state.GameEdit.reordering)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveTo(-3))),
                  class: _normalizeClass({page:true, clickable:true, active:_ctx.$store.state.GameEdit.cards.focus=='stats'})
                }, [
                  _createVNode(_component_Ripple),
                  _createVNode(_component_MovingIcon, {
                    name: "trend",
                    type: "svg"
                  })
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveTo(-1))),
                  class: _normalizeClass({page:true, clickable:true, active:_ctx.$store.state.GameEdit.cards.focus=='meta'})
                }, [
                  _createVNode(_component_Ripple),
                  _createVNode(_component_MovingIcon, {
                    name: "details",
                    type: "svg"
                  })
                ], 2)
              ], 64))
            : _createCommentVNode("", true),
          ((_ctx.$store.state.GameEdit.cards && _ctx.$store.state.GameEdit.cards.data) && _ctx.$store.state.GameEdit.cards.data.length == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addCard && _ctx.addCard(...args))),
                class: _normalizeClass({missing:true, page:true, clickable:true})
              }, [
                _createElementVNode("div", {
                  class: "image _img",
                  style: _normalizeStyle(`background-image:url(${'https://cdn.jsdelivr.net/npm/movingicons_assets/svg/cross.svg'})`)
                }, null, 4),
                _hoisted_3
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.$store.state.GameEdit.cards.data, (card) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.moveTo(card.index)),
                  class: _normalizeClass({page:true, clickable:true, active:_ctx.$store.state.GameEdit.cards.focus==card.index})
                }, [
                  _createVNode(_component_Ripple),
                  (_ctx.$store.state.GameEdit.reordering)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          class: "image _img",
                          style: _normalizeStyle(`background-image:url(${card.image || 'https://cdn.jsdelivr.net/npm/movingicons_assets/svg/missing.svg'})`)
                        }, null, 4),
                        _createElementVNode("div", _hoisted_5, [
                          (!card.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Untitled"))
                            : (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(card.title), 1)),
                          (card.questions && card.questions.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.questions, (question) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_9, " ? - " + _toDisplayString(question.question), 1))
                                }), 256))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, "No questions"))
                        ]),
                        _hoisted_11,
                        _createElementVNode("div", {
                          class: "orderer",
                          onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                          onTouchstart: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_Ripple),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_IconButton, {
                              icon: "up",
                              white: true,
                              clear: true,
                              onClick: ($event: any) => (_ctx.moveToIndex(card, card.index-1))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_IconButton, {
                              icon: "down",
                              white: true,
                              clear: true,
                              onClick: ($event: any) => (_ctx.moveToIndex(card, card.index+1))
                            }, null, 8, ["onClick"])
                          ])
                        ], 32)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(card.index), 1)
                      ], 64))
                ], 10, _hoisted_4))
              }), 256)),
          (_ctx.gameeditmeta && _ctx.$store.state.GameEdit.cards && !_ctx.$store.state.GameEdit.reordering)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveTo(-4))),
                class: _normalizeClass({page:true, clickable:true, active:_ctx.$store.state.GameEdit.cards.focus=='door'})
              }, [
                _createVNode(_component_Ripple),
                _createVNode(_component_MovingIcon, {
                  name: "door",
                  type: "svg"
                })
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.$store.state.GameEdit.reordering)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_IconButton, {
            icon: "chevron_right",
            white: true,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.moveTo(_ctx.$store.state.GameEdit.cards.focus=='meta'?0:_ctx.$store.state.GameEdit.cards.focus+1)))
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}